import { Amplify } from 'aws-amplify';
const amplifyConfig = {
    region: 'eu-central-1',
    userPoolId: process.env.AWS_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.AWS_APP_CLIENT_ID,
};
Amplify.configure(amplifyConfig);
